import actionTypes from 'constants/actionTypes';

import { TradingOfferType } from 'types/TradingOffer';
import { AddTradingOfferPageProvider } from '../pages/AddTradingOffer/context/AddTradingOfferPageContext';
import AddTradingOfferPage from '../pages/AddTradingOffer';

const AddSellTradingOfferPageContainer = () => (
  <AddTradingOfferPageProvider
    tradingOfferType={TradingOfferType.SELL}
    actionType={actionTypes.ADD}
  >
    <AddTradingOfferPage />
  </AddTradingOfferPageProvider>
);

export default AddSellTradingOfferPageContainer;
